import Repository from '../../Repository';

export class UserRepository extends Repository {
    constructor() {
        super();
        this.resource = 'users'
    }

    deactivate(user_id) {
        return this.put(`${user_id}/deactivate`);
    }

    activate(user_id) {
        return this.put(`${user_id}/activate`);
    }

    makePrimary(user_id) {
        return this.post(`${user_id}/make-primary`);
    }

    updateProfile(data) {
        return this.put('', data);
    }

    updateEmail(data) {
        return this.post('update-email', data);
    }

    link(data) {
        return this.post('link', data);
    }

    updateMfa({user_id}, data) {
        return this.put(`${user_id}/mfa`, data);
    }
}

const Users = new UserRepository();

export default Users;
